<template>
  <div>
    <v-container class="grey lighten-5">
      <v-card dense :loading="loading" outlined elevation="25" class="">
          <v-card-title class="my-0">
            <Link :href="baseurl+'/job/'+job.alias" class="text-lg-h5 text-md-h5 text-sm-h6">{{job.title}}</Link>
              
            <v-icon color="primary" class="ml-5"  v-if="job.isFeatured">mdi-star-box-outline</v-icon>
            
            <v-spacer></v-spacer>
            
            <Link :href="baseurl+'/job/'+job.alias">
                  <v-icon style="margin-right:3px">mdi-eye</v-icon>
              </Link>
            <v-icon v-if="!job.isFavorite" @click="triggerAddFavorite()" class="m-5" color="primary">mdi-heart-outline</v-icon>
            <v-icon v-if="job.isFavorite" @click="triggerDelFavorite()" class="m-5" color="primary">mdi-heart</v-icon>
          </v-card-title>
          <v-card-text class="hidden-md-and-down">
            <v-container>
              <v-row>
                <v-col cols=12 lg="12" class="d-flex justify-center align-center">
                
                    <v-img 
                    v-if="job.organization.photo_path"
                    max-height="100"
                    contain
                      :src="baseurl + '/img/'+job.organization.photo_path">
                    </v-img>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="12">
                  <span><v-icon class="mr-3">mdi-shape</v-icon>{{job.category.title}}</span>
                </v-col>
              </v-row>
                <v-row>
                  <v-col cols="12" sm="12" lg="4" md="4" v-if="job.region">
                      <span><v-icon class="mr-3">mdi-map</v-icon>{{job.region}}</span>
                  </v-col>
                  <v-col cols="12" sm="12" lg="4" md="4" v-if="job.awarding_body">
                    <span><v-icon class="mr-3">mdi-license</v-icon><span v-html="job.awarding_body"></span></span>
                  </v-col>
                  <v-col cols="12" sm="12" lg="4" md="4" v-if="job.duration">
                    <span><v-icon class="mr-3">mdi-clock</v-icon><span v-html="job.duration"></span></span>
                  </v-col>
                </v-row>
                
                
            </v-container>
          </v-card-text>
          

      </v-card>   
    </v-container>
   

  </div>
</template>
<script>
import { Head } from '@inertiajs/inertia-vue'
import Layout from '@/Shared/VuetifyLayout'
import axios from 'axios'

import { Link } from '@inertiajs/inertia-vue'

export default {
  props: {
    job: Object,
    auth: Object,
    state: String,
    baseurl: String,
    prevurl: String,
  },
  components: {
    Head,
    Link
  },
  layout: Layout,
  data() {
      return {
          applyDialog: false,
          loading: false,
      }
  },
  watch: {
  },
  created() {
  },
  methods: {  
    
    getUrl() {
        return 'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(this.job.address +','+this.job.region)

    },
    canApply() {
      if (!this.auth.user || (this.auth.user.roles.includes('admin') || this.auth.user.roles.includes('user')))
          return true;
      else
          return false;
    },
    triggerApply() {
      console.log('trigger apply');
      if (!this.auth.user)
          this.$emit('toggleComponentLogin','jobapply-'+this.job.id);
      else if (this.job.job_link)
          window.open(window.location + '/apply')
      else
          this.applyDialog = true;
          
    },
    triggerAddFavorite() {
      this.loading=true;
      console.log('trigger addfavorite');
      let vm = this;
      if (!this.auth.user)
          this.$emit('toggleComponentLogin','jobaddfavorite-'+this.job.id);
      else
          this.$inertia.get(this.baseurl+"/user/job/addfavorite/"+this.job.id,{},{
            preserveState: true,
            preserveScroll: true,
            onFinish: visit => {
              // This won't be called until doThing()
              // and doAnotherThing() have finished.
              vm.loading = false;
            },
          })
    },
    triggerDelFavorite() {
      this.loading = true;
      let vm = this;
      console.log('trigger delfavorite',this.auth.user,this.baseurl+"/user/job/delfavorite/"+this.job.id);
      if (!this.auth.user)
        this.$emit('toggleComponentLogin','jobdelfavorite-'+this.job.id);
      else
          this.$inertia.get(this.baseurl+"/user/job/delfavorite/"+this.job.id,{},{
            preserveState: true,
            preserveScroll: true,
            onFinish: visit => {
              vm.$emit('refresh');
              // This won't be called until doThing()
              // and doAnotherThing() have finished.
              vm.loading = false;
            },
          });
    }
  },
}
</script>

<style>
  .fixedFooter {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
  }
  </style>